export default "__VITE_ASSET__D0edF0Jc__"